webpackJsonp([11],{

/***/ 751:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Stat.vue


/* harmony default export */ var Stat = ({
  props: {
    title: {
      type: String,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a245f3c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Stat.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"text-xs-center"},[_c('v-card-title',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('v-card-text',[(_vm.loading)?_c('v-progress-circular',{staticClass:"primary--text",attrs:{"indeterminate":"","height":2}}):_vm._e(),_vm._v(" "),_vm._t("default")],2),_vm._v(" "),(_vm.$slots.actions)?_c('v-card-row',{attrs:{"actions":""}},[_vm._t("actions")],2):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_Stat = (esExports);
// CONCATENATED MODULE: ./src/components/Stat.vue
function injectStyle (ssrContext) {
  __webpack_require__(767)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4a245f3c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Stat,
  components_Stat,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_Stat = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 752:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__(3);
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/DateIntervalPicker.vue



/* harmony default export */ var DateIntervalPicker = ({
  props: {
    value: {
      type: Array,
      default: function _default() {
        return [null, null];
      }
    }
  },
  data: function data() {
    var _this = this;

    return {
      popup: false,
      dates: this.value.map(function (value, i) {
        return {
          value: value,
          title: _this.$t('dateintervalpicker.dates.' + i),
          menu: false
        };
      })
    };
  },

  computed: {
    tr: function tr() {
      return {
        'night': 'jour',
        'nights': 'jours',
        'check-in': 'Du',
        'check-out': 'au',
        'day-names': ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
        'month-names': ['Jan', 'Fev', 'Mars', 'Avril', 'Mai', 'Juin', 'Juill', 'Août', 'Sept', 'Oct', 'Nov', 'Déc']
      };
    }
  },
  methods: {
    emit: function emit() {
      this.popup = false;
      this.$emit('input', this.dates.map(function (x) {
        return x.value;
      }));
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.dates = this.dates.map(function (date, i) {
      return extends_default()({}, date, {
        menu: date.value && !(_this2.dates[i + 1] || {}).value
      });
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4413915a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DateIntervalPicker.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{model:{value:(_vm.popup),callback:function ($$v) {_vm.popup=$$v},expression:"popup"}},[_c('v-btn',{staticClass:"fixed",attrs:{"slot":"activator","floating":""},slot:"activator"},[_c('v-icon',[_vm._v("today")])],1),_vm._v(" "),_c('v-card',[_c('v-expansion-panel',_vm._l((_vm.dates),function(date,i){return _c('v-expansion-panel-content',{key:i,attrs:{"value":date.menu && _vm.popup}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v(_vm._s(date.title)+" "+_vm._s(date.value))]),_vm._v(" "),_c('v-card',[_c('v-date-picker',{staticClass:"elevation-0",attrs:{"no-title":""},model:{value:(date.value),callback:function ($$v) {_vm.$set(date, "value", $$v)},expression:"date.value"}})],1)],1)}),1),_vm._v(" "),_c('v-card-row',{attrs:{"actions":""}},[_c('v-btn',{attrs:{"block":"","primary":"","light":""},nativeOn:{"click":function($event){$event.stopPropagation();return _vm.emit.apply(null, arguments)}}},[_c('v-icon',{staticClass:"mr-2",attrs:{"light":""}},[_vm._v("check")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_DateIntervalPicker = (esExports);
// CONCATENATED MODULE: ./src/components/DateIntervalPicker.vue
function injectStyle (ssrContext) {
  __webpack_require__(753)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4413915a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  DateIntervalPicker,
  components_DateIntervalPicker,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_DateIntervalPicker = (Component.exports);

// CONCATENATED MODULE: ./src/mixins/withInterval.js



/* harmony default export */ var withInterval = __webpack_exports__["a"] = ({
  components: {
    DateIntervalPicker: src_components_DateIntervalPicker
  },
  data: function data() {
    return {
      interval: [this.$route.query.from || null, this.$route.query.to || null]
    };
  },

  computed: {
    params: function params() {
      return this.$route.query;
    }
  },
  watch: {
    interval: function interval() {
      this.$router.replace(extends_default()({}, this.$route, {
        query: extends_default()({}, this.$route.query, {
          from: this.interval[0],
          to: this.interval[1]
        })
      }));
    }
  }
});

/***/ }),

/***/ 753:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(754);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(747)("18c27bb6", content, true);

/***/ }),

/***/ 754:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(746)(true);
// imports


// module
exports.push([module.i, ".fixed[data-v-4413915a]{z-index:1}.picker[data-v-4413915a]{max-width:100%}", "", {"version":3,"sources":["/home/runner/work/manager/manager/src/components/DateIntervalPicker.vue"],"names":[],"mappings":"AACA,wBAA0B,SAAW,CACpC,AACD,yBAA2B,cAAgB,CAC1C","file":"DateIntervalPicker.vue","sourcesContent":["\n.fixed[data-v-4413915a] { z-index: 1;\n}\n.picker[data-v-4413915a] { max-width: 100%;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 767:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(768);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(747)("a54c80b0", content, true);

/***/ }),

/***/ 768:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(746)(true);
// imports


// module
exports.push([module.i, ".card__title[data-v-4a245f3c]{text-align:center}.card__text[data-v-4a245f3c],.card__title[data-v-4a245f3c]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.card__text[data-v-4a245f3c]{font-size:3em;padding-top:0;-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex}.progress-circular[data-v-4a245f3c]{position:absolute;top:.25em;right:.25em}", "", {"version":3,"sources":["/home/runner/work/manager/manager/src/components/Stat.vue"],"names":[],"mappings":"AACA,8BACE,iBAAmB,CAIpB,AACD,2DAJE,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CAcjC,AAZD,6BACE,cAAe,AACf,cAAe,AAIf,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,oBAAqB,AACrB,oBAAqB,AACrB,YAAc,CACf,AACD,oCACE,kBAAmB,AACnB,UAAW,AACX,WAAa,CACd","file":"Stat.vue","sourcesContent":["\n.card__title[data-v-4a245f3c] {\n  text-align: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.card__text[data-v-4a245f3c] {\n  font-size: 3em;\n  padding-top: 0;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.progress-circular[data-v-4a245f3c] {\n  position: absolute;\n  top: .25em;\n  right: .25em;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 984:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__(92);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(93);
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/toConsumableArray.js
var toConsumableArray = __webpack_require__(40);
var toConsumableArray_default = /*#__PURE__*/__webpack_require__.n(toConsumableArray);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__(3);
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__(7);

// EXTERNAL MODULE: ./src/api/metrics.js
var metrics = __webpack_require__(365);

// EXTERNAL MODULE: ./src/components/formatters/index.js + 12 modules
var formatters = __webpack_require__(48);

// EXTERNAL MODULE: ./src/components/Stat.vue + 2 modules
var Stat = __webpack_require__(751);

// EXTERNAL MODULE: ./src/mixins/withInterval.js + 3 modules
var withInterval = __webpack_require__(752);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/Statistics.vue











/* harmony default export */ var Statistics = ({
  components: {
    Stat: Stat["a" /* default */],
    Minute: formatters["c" /* Minute */],
    Price: formatters["d" /* Price */]
  },
  mixins: [withInterval["a" /* default */]],
  data: function data() {
    return {
      data: {
        experts: [],
        price: {}
      },
      loading: false
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    currentUser: 'skiliko/session/currentUser'
  }), {
    headers: function headers() {
      return [{ text: this.$t('pages.statistics.expert'), left: true, sortable: false }, { text: this.$t('pages.statistics.sum'), left: false, sortable: false }, { text: this.$t('pages.statistics.total'), left: false, sortable: false }, { text: this.$t('pages.statistics.average'), left: false, sortable: false }, { text: this.$t('pages.statistics.gains'), left: false, sortable: false }];
    },
    filteredData: function filteredData() {
      var _this = this;

      return this.$can('viewStats', 'team') ? [].concat(toConsumableArray_default()(this.data.experts)) : this.data.experts.filter(function (x) {
        return x.expert.id === _this.currentUser.id;
      });
    },
    sum: function sum() {
      return this.filteredData.map(function (x) {
        return x.call_duration.total;
      }).reduce(function (res, x) {
        return res + x;
      }, 0);
    },
    total: function total() {
      return this.filteredData.map(function (x) {
        return x.call_duration.count;
      }).reduce(function (res, x) {
        return res + x;
      }, 0);
    },
    average: function average() {
      return this.filteredData.map(function (x) {
        return x.call_duration.avg;
      }).reduce(function (res, x) {
        return res + x;
      }, 0) / this.filteredData.length;
    },
    stats: function stats() {
      var collectorValue = this.data.collector ? [].concat(toConsumableArray_default()(this.data.collector.availables), toConsumableArray_default()(this.data.collector.pendings)).reduce(function (prev, x) {
        return prev + x.amount;
      }, 0) : 0;
      return [{ key: 'sum', component: formatters["c" /* Minute */], value: this.sum }, { key: 'total', value: this.total }, { key: 'average', component: formatters["c" /* Minute */], value: this.average }, this.data.price && this.data.price.minute ? { key: 'price_minute', component: formatters["d" /* Price */], value: this.data.price.minute } : null, this.data.price && this.data.price.average ? { key: 'price_average', component: formatters["d" /* Price */], value: this.data.price.average } : null, this.data.collector ? { key: 'collector', component: formatters["d" /* Price */], value: collectorValue } : null].filter(function (x) {
        return x;
      });
    }
  }),
  methods: {
    reloadStats: function reloadStats() {
      var _this2 = this;

      return asyncToGenerator_default()(regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.loading = true;
                _context.next = 3;
                return metrics["a" /* default */].expertStats({ params: _this2.params });

              case 3:
                _this2.data = _context.sent.data;

                _this2.loading = false;

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    }
  },
  watch: {
    params: function params() {
      this.reloadStats();
    }
  },
  mounted: function mounted() {
    this.reloadStats();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b5694be","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Statistics.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('h1',{staticClass:"headline"},[_vm._v(_vm._s(_vm.$t('pages.statistics.title')))]),_vm._v(" "),_c('DateIntervalPicker',{staticClass:"mb-3",model:{value:(_vm.interval),callback:function ($$v) {_vm.interval=$$v},expression:"interval"}}),_vm._v(" "),(_vm.loading)?_c('v-progress-circular',{attrs:{"indeterminate":""}}):_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.stats),function(stat){return _c('v-flex',{key:stat.key,staticClass:"mb-3",attrs:{"xs12":"","sm4":""}},[_c('stat',{attrs:{"title":_vm.$t(("pages.statistics." + (stat.key)))}},[(stat.component)?_c(stat.component,{tag:"component",attrs:{"value":stat.value}}):_c('span',[_vm._v(_vm._s(stat.value))])],1)],1)}),1),_vm._v(" "),(_vm.$can('viewStats', 'team'))?_c('v-card',[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.filteredData,"custom-sort":function (a) { return a; },"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_c('router-link',{attrs:{"to":{ name: 'Expert', params: { id: props.item.expert.id, tab: 'profile' } }}},[_vm._v("\n            "+_vm._s(props.item.expert.nickname)+"\n          ")])],1),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_c('minute',{attrs:{"value":props.item.call_duration.total}})],1),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.call_duration.count))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_c('minute',{attrs:{"value":props.item.call_duration.avg}})],1),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_c('price',{attrs:{"value":props.item.gains.sum}})],1)]}}],null,false,1566768685)})],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var pages_Statistics = (esExports);
// CONCATENATED MODULE: ./src/pages/Statistics.vue
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Statistics,
  pages_Statistics,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_pages_Statistics = __webpack_exports__["default"] = (Component.exports);


/***/ })

});


// WEBPACK FOOTER //
// static/js/11.94bcae696b6911fb4a72.js